import { EuiFlexGroup, EuiFlexItem, EuiPanel } from '@elastic/eui';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { SidebarAjustesCostosExpatriados } from './sidebar/component';
import { AjusteExpatriadoDobleRetencion } from './detalle/DobleRetencion/component';
import { AjusteExpatriadoDobleDestino } from './detalle/DobleDestino/component';
import { AjusteExpatriadoMenosUnMes } from './detalle/MenosUnMes/component';
import './styles.css';
import { AjusteExpatriadoObra } from './detalle/Obra/component';
import { AnioActual, MesActual } from '../../../../../shared/utils/constants';



export const AjustesCostosExpatriadosScreen = ()=>{

    const [filter,setFilter] = useState<any>(undefined);
    const [selected, setSelected] = useState<any>(undefined);

    useEffect(()=>{setSelected(undefined)},[filter])

    const savePermission = useMemo(()=> {
        return filter && ((filter.anio<AnioActual && (MesActual===1 && filter.mes===12)) || 
        (filter.anio===AnioActual && (filter.mes===MesActual || filter.mes===MesActual-1)))
    },[filter,AnioActual,MesActual])

    const getDetalle = useCallback(() =>{
        if(selected!==undefined){
                switch (filter.tipo) {
                    case 'dr':
                        return <AjusteExpatriadoDobleRetencion selected={selected} filter={filter} savePermission={savePermission} handleRefreshStateUsers={setSelected}/>;
                    case 'dd':
                        return <AjusteExpatriadoDobleDestino selected={selected} filter={filter} savePermission={savePermission} handleRefreshStateUsers={setSelected}/>;
                    case 'mm':
                        return <AjusteExpatriadoMenosUnMes selected={selected} filter={filter} savePermission={savePermission} handleRefreshStateUsers={setSelected}/>;
                    case 'o':
                        return <AjusteExpatriadoObra selected={selected} filter={filter} savePermission={savePermission} handleRefreshStateUsers={setSelected}/>;
                    default:
                        return null
                }
        }
        return null;
    },[filter,selected])

    return (
        <EuiFlexGroup direction='column' style={{height:'100%'}} gutterSize='none'>
            <EuiFlexItem style={{height:'100%'}}>
                <EuiFlexGroup style={{height:'100%'}} gutterSize='none'>
                    <EuiFlexItem grow={2} style={{overflow:'hidden'}}>
                        <EuiPanel style={{overflow:'hidden',borderTopRightRadius:'0px',borderBottomRightRadius:'0px'}}>
                        <EuiFlexGroup direction='column' style={{height:'100%'}}>
                        <SidebarAjustesCostosExpatriados onChangeFilter={setFilter} filter={filter} handleUserClick={setSelected} selected={selected}/> 
                        </EuiFlexGroup>
                        </EuiPanel>
                    </EuiFlexItem> 
                    <EuiFlexItem grow={8}>
                    {getDetalle()}
                    </EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlexItem>  
        </EuiFlexGroup> 
    )
}